module.exports = __webpack_public_path__ + "img/battle.2d3ac2fc.png";